import { useMemo } from 'react';
import { get } from 'lodash';

import { useGetPackageData } from './useGetPackageData';

import type { PackageDepartureHotelImage } from '@lt/api/dist/methods/packages/types';
import type { IHotelGalleryImages } from '@lt/components/components/HotelCard/components/HotelCardGallery';

type Return = {
  hotelGalleryImages: IHotelGalleryImages;
};

export const useGetHotelGalleryImages = (): Return => {
  const { packageData } = useGetPackageData();
  const hotelGalleryImages = useMemo(() => {
    const hotelImages: Partial<PackageDepartureHotelImage>[] = get(
      packageData,
      ['hotel', 'images'],
      []
    );
    const imagesLinks = hotelImages.map((item) => ({ jpg: item.x900 })).filter((item) => item) as {
      jpg: string;
    }[];
    const imagesCount = hotelImages.length;

    return {
      list: imagesLinks || [],
      count: imagesCount || 0,
    };
  }, [packageData]);

  return { hotelGalleryImages };
};
